<!-- <div class="footer-wrap">
  <div class="credentials">
    <p>Copyright &copy; 1994-{{year}} United Parcel Service of America, Inc. All rights reserved.</p>
    <ul class="links">
      <li>
        <a href="https://www.ups.com/us/en/global.page?" target="_blank">Global Home</a>
      </li>
      <li>
        <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/fight-fraud.page?" target="_blank">Protect Against Fraud</a>
      </li>
      <li>
        <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/service.page?" target="_blank">Service Terms and Conditions</a>
      </li>
      <li>
        <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/website.page?" target="_blank">Web Site Terms of Use</a>
      </li>
      <li>
        <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/privacy-notice.page" target="_blank">Privacy Notice</a>
      </li>
      <li>
        <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/california-privacy.page?" target="_blank">Your California Privacy Rights</a>
      </li>
      <li>
        <a class="disclaimer" #disclaimer (click)="toggleDisclaimer()">
          cGMP Disclaimer
          <span class="disclaimer-popup">
            <h4>Disclaimer</h4>
            <p>This Portal is not validated per global healthcare regulatory requirements and shouldn’t be used when validated reports and data are required.</p>
          </span>
        </a>
      </li>
    </ul>
  </div>
</div> -->
<div class="site-footer-document">
  <div class="site-footer-layout">
    <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="footer-col">
          <h3>Other UPS Mail Innovation Sites</h3>
          <ul>
            <a href="https://mibilling.ups.com/">MI Billing</a> &nbsp; &nbsp; <span class="separator">|</span>
            <a href="https://miratecase.mailinnovations.ups.com/landing-page">MI Rate Case</a>&nbsp; &nbsp; <span class="separator">|</span>
            <a href="https://wap-mis-config-web-prdr1.azurewebsites.net/">MI Config</a>
          </ul>
        </div>
      </div>
      <hr>
      <div class="footer-wrap">
        <div class="credentials">
          <a href="https://www.ups.com/us/en/global.page?" target="_blank" class="linkcol">Global Home</a>
          <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/fight-fraud.page?" target="_blank" class="linkcol">Protect Against Fraud</a>
          <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/service.page?" target="_blank" class="linkcol">Service Terms and Conditions</a>
          <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/website.page?" target="_blank" class="linkcol">Web Site Terms of Use</a>
          <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/privacy-notice.page" target="_blank" class="linkcol">Privacy Notice</a>
          <a href="https://www.ups.com/us/en/help-center/legal-terms-conditions/california-privacy.page?" target="_blank" class="linkcol">Your California Privacy Rights</a>
          <a class="disclaimer" #disclaimer (click)="toggleDisclaimer()">
            cGMP Disclaimer
            <span class="disclaimer-popup">
              <h4>Disclaimer</h4>
              <p>This Portal is not validated per global healthcare regulatory requirements and shouldn’t be used when validated reports and data are required.</p>
            </span>
          </a>
          <p class="copyright">
            Copyright &copy; 1994-{{year}} United Parcel Service of America, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </div>
    </footer>
  </div>
</div>
